// TAPINTO® Editor Frontend - Loading Spinner Component
// Version: 1.0
// Date: 2025-10-01

import { cn } from '../../utils/helpers';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function LoadingSpinner({ size = 'md', className }: LoadingSpinnerProps) {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-6 w-6',
    lg: 'h-8 w-8',
  };

  return (
    <div
      className={cn(
        'animate-spin rounded-full border-2 border-neutral-300 border-t-primary-500',
        sizeClasses[size],
        className
      )}
    />
  );
}
